import { useQueryClient } from "@tanstack/react-query";
import { trpc } from "../trpc";
import { getQueryKey } from "@trpc/react-query";

export function useTestAuthentication() {
  const queryClient = useQueryClient();

  const authenticationsKey = getQueryKey(
    trpc.authentication.authentications,
    undefined,
    "any",
  );

  const mutation = trpc.authentication.testAuthentication.useMutation({
    // Callback to handle optimistic updates in RQ cache
    onMutate: ({ id }) => {
      if (!id) {
        return;
      }

      // Update Authentication under the authentications list key
      queryClient.cancelQueries({ queryKey: authenticationsKey });
    },
    onSettled: () => {
      // Invalidate authentications key to refetch data
      queryClient.invalidateQueries({ queryKey: authenticationsKey });
    },
  });

  return {
    isError: mutation.isError,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    mutate: mutation.mutate,
  };
}
